import VCDealFlows from './VCDealFlows';

export default VCDealFlows;
